import { ReactComponent as WarningIcon } from "../../../assets/images/warning_with_person.svg";

const ErrorFallback = ({ error }) => {
  const handleGoBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/my_space";
    }
  };

  console.log("Crash detected:", error);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center p-6">
      <WarningIcon className="w-64 h-64 mb-4" />
      <h1 className="text-2xl font-semibold text-gray-800 mb-4">Oops! Something went wrong.</h1>
      <p className="text-gray-600 mb-4">
        We encountered an unexpected error. Our team has been notified and is working to resolve the issue.
      </p>
      <p className="text-gray-600 mb-4">
        If you need immediate assistance, please contact support or try going back and refreshing the page.
      </p>

      <br />
      <br />
      <br />
      <p className="text-gray-600 mb-6">Please try going back and refreshing the app.</p>
      <button
        onClick={handleGoBack}
        className="bg-indigo-600 text-white px-5 py-2 rounded-lg shadow hover:bg-indigo-700 transition"
      >
        Go Back
      </button>
    </div>
  );
};

export default ErrorFallback;
